export class SurveyResearchHeaderModel {
  id: number;
  hotel_id: number;
  title: string;
  description: string;
  image_url: string;
  type: string;
  status: number;
  create_date: Date;
  send_only_in_hotel: boolean;
  sent: number;
  converted: number;
  remaining: number;

  constructor(id = 0,
              hotel_id = 0,
              title = '',
              description = '',
              image_url = '',
              type = '',
              status = 1,
              create_date = new Date(),
              send_only_in_hotel = true,
              sent = 0,
              converted = 0,
              remaining = 0,
              ) {
    this.id = id;
    this.hotel_id = hotel_id;
    this.title = title;
    this.description = description;
    this.image_url = image_url;
    this.type = type;
    this.status = status;
    this.create_date = create_date;
    this.send_only_in_hotel = send_only_in_hotel;
    this.sent = sent;
    this.converted = converted;
    this.remaining = remaining;
  }
}
